import './Header.css';

const Header = () => {
    return (
        <header>
            <img src="./uma-logo.png" />
            <h1>Upgrade CRM</h1>
        </header>
    );
};

export default Header;
